import { storableError } from '../util/errors';
import { logError } from '../util/log';

// ================ Action types ================ //

export const SAVE_FILTERS_REQUEST = 'app/InboxPage/SAVE_FILTERS_REQUEST';
export const SAVE_FILTERS_SUCCESS = 'app/InboxPage/SAVE_FILTERS_SUCCESS';
export const SAVE_FILTERS_ERROR = 'app/InboxPage/SAVE_FILTERS_ERROR';

// ================ Reducer ================ //

/** @type {import('../../types/vansite').VanSite.State.MainPanel} */
const initialState = {
  saveFiltersInProgress: false,
  saveFiltersError: null,
};

export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    // Existing cases...

    case SAVE_FILTERS_REQUEST:
      return { ...state, saveFiltersInProgress: true, saveFiltersError: null };
    case SAVE_FILTERS_SUCCESS:
      return { ...state, saveFiltersInProgress: false };
    case SAVE_FILTERS_ERROR:
      return { ...state, saveFiltersInProgress: false, saveFiltersError: payload };

    default:
      return state;
  }
}

// ================ Action creators ================ //

const saveFiltersRequest = () => ({ type: SAVE_FILTERS_REQUEST });
const saveFiltersSuccess = (response) => ({
  type: SAVE_FILTERS_SUCCESS,
  payload: response,
});
const saveFiltersError = (e) => ({
  type: SAVE_FILTERS_ERROR,
  error: true,
  payload: e,
});

// ================ Thunks ================ //

export const saveFilters = (filters) => async (dispatch, getState, sdk) => {
  const currentUser = getState().user.currentUser;
  if (!currentUser) return;

  dispatch(saveFiltersRequest());
  try {
    const response = await sdk.currentUser.updateProfile({
      privateData: {
        filters,
      },
    });

    dispatch(saveFiltersSuccess(response));
  } catch (e) {
    logError(e, 'save-filters-failed');
    dispatch(saveFiltersError(storableError(e)));
  }
};

export const loadData = (params, search) => (dispatch, getState) => {
  const filters = getState().someFilterState; // Replace with the actual state selector
  const userId = getState().user.id; // Replace with the actual user selector

  if (filters) {
    dispatch(saveFilters(filters));
  }

  return dispatch(saveFilters(filters));
};
